$(function() {
  const $hamburger = $('.js-hamburger');
  const $menu = $('.js-menu');
  const $menuWrapper = $('#menus');
  const $searchInputWrapper = $('.js-search-input-wrapper');
  const $searchIcon = $('.js-search-icon');

  const toggleMenu = function() {
    $searchInputWrapper.addClass('js-dn');
    $searchIcon.removeClass('active');

    $menu.toggleClass('js-dn');
    $menuWrapper.toggleClass('menu-active');
    $hamburger.toggleClass('active');
  };

  $hamburger.on('click', e => toggleMenu());
});
